<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
            <div class="d-flex no-wrap gap-2 mb-3-rem" v-for="(item, index) in application" :key="item.id">
                <div class="flex-1">
                    <v-label>{{$t("res_Label_Applications")}}</v-label>
                    <v-text-field :value="application[index].text" solo disabled dense height="40px"></v-text-field>
                </div>
                <div class="flex-1 ">
                    <v-label>{{$t("res_Label_Roles")}}</v-label>
                    <Multiselect class="light-bg add-arrow" v-model="roleCts[index]"
                        label="name" track-by="id" open-direction="bottom" placeholder="Select role"
                        :options="roles" :searchable="true" :loading="loading"
                        :internal-search="false" @search-change="getRoles" :clear-on-select="true"
                        :close-on-select="true" :options-limit="300" :max-height="600"
                        :show-no-results="false" :hide-selected="false" :multiple="false" solo>
                    </Multiselect>
                </div>
                <div class="flex-1 ">
                    <v-label>{{$t("res_Label_UserType")}}</v-label>
                    <Multiselect class="light-bg add-arrow" v-model="userTypeCts[index]"
                        label="text" track-by="id" open-direction="bottom"
                        placeholder="Select user type" :options="userTypes" :searchable="true"
                        :loading="loading" :internal-search="false" :clear-on-select="true"
                        :close-on-select="true" :options-limit="300" :max-height="600"
                        :show-no-results="false" :hide-selected="false" :multiple="false">
                    </Multiselect>
                </div>
            </div>
        </div>

        <v-card-actions class="gap-2 sticky-actions">
            <v-spacer></v-spacer>
            <v-btn class="light-blue" style="min-width: 100px !important" @click="close()">{{$t("res_ButtonText_Cancel")}}</v-btn>
            <v-btn class="primary" style="min-width: 100px !important" @click="addApplicationRoles()">{{$t("res_ButtonText_Save")}}</v-btn>
        </v-card-actions>
        
    </div>
</template>

<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants'
    import Multiselect from 'vue-multiselect'

    export default {
        name: 'ManageApplicationRoles',
        components: { Multiselect },
        data: function () 
        {
            return {
                loading: false,
                userTypeCts: [{ text: 'Editor', id: '1' }, { text: 'Editor', id: '1' }],
                roleCts: [{ id: '7', name: 'Business User' }, { id: '7', name: 'Business User' }],
                application: [
                    { text: 'CTS', id: '1' },
                    { text: 'VIEWER', id: '2' }
                ],
                userTypes: [
                    { text: 'Editor', id: '1' },
                    { text: 'Readonly', id: '2' }
                ],
                roles: [],
                addUserApplicaitionRole: [],
            };
        },
        props: {
            userId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
        },
        methods: 
        {
            initForm()
            {
                this.getRoles();
            },
            getRoles() 
            {
                axios.get(constants.baseApiUrl + 'User/GetRoles', { headers: constants.headers })
                    .then(response => 
                    {
                        if (response.data != null) 
                        {
                            this.roles = [];

                            response.data.forEach(element => {
                                let myobj = {};
                                myobj.id = element.roleId;
                                myobj.name = element.roleName;

                                this.roles.push(myobj)
                            });
                        }
                    })
                    .catch(error => this.loading = false)
            },
            getApplicatinRoles()
            {
                axios.post(constants.baseApiUrl + 'User/GetUserApplicationRoles?userId=' + this.userId, { headers: constants.headers })
                    .then(res => 
                    {
                        if (res.data != null)
                        {
                            this.userForm.roleCts = [];
                            res.data.forEach(element => {
                                let myobj = {
                                    id: element.roleId,
                                    name: element.roleName
                                }
                                this.roleCts.push(myobj)
                            });
                            this.fetchNewStructure();
                        }
                    }).catch(err => console.warn(err));
            },
            addApplicationRoles()
            {
                this.addUserApplicaitionRole = [];

                this.addUserApplicaitionRole.push({
                    RoleId: this.roleCts[0].id,
                    ApplicationId: this.application[0].id,
                    UserId: this.userId,
                    UserTypeId: this.userTypeCts[0].id
                });

                this.addUserApplicaitionRole.push({
                    RoleId: this.roleCts[1].id,
                    ApplicationId: this.application[1].id,
                    UserId: this.userId,
                    UserTypeId: this.userTypeCts[1].id
                });

                axios.post(constants.baseApiUrl + 'User/AddUserApplicationRole', this.addUserApplicaitionRole, { headers: constants.headers })
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            window.showAlert('The new User applicatin role added successfully', 'success')
                            this.close();
                        }
                    }).catch(error => this.loading = false);
            },
            close()
            {
                this.$emit('closeDialog')
            },
        },
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                        this.initForm()
                }
            }
        },
        mounted: function () 
        {
            this.initForm();
        }
    }
</script>